
import { entryShop } from "@/utils/platform";
import React from "react";
// import { useSearchParams } from "react-router-dom";
import PlantGrassSection from "./components/PlantGrassSection";
import styles from "./index.module.less";
import { useTrack } from "./track";

/**
 * 逛一逛页面、种草专区页面，通过fromPage区分
 * materialNo: string  素材编号
 * shopId: string  店铺id
 * distributorId: string  分销员id
 * objectIds string,string  用于根据商品查询的信息
 * queryType 用于根据商品查询的信息
 * baseProductIds string,string 用于根据商品查询的信息
 */
const RealhotList: React.FC = () => {
  const myTrack = useTrack();
  // const [search] = useSearchParams();


  const init = async () => {
    document.title = "种草专区";
    entryShop();
    myTrack.trackPageView({ tab: 1 });
  };


  React.useEffect(() => {
    init();
  }, []);


  return (
    <div className={styles["PlantGrassSection-container"]}>
      <PlantGrassSection />
    </div>
  );
};

export default RealhotList;
